import Repository from "@/repositories/api.js"
const resource = "/super_admin/districts"

export default {
  async getDistricts() {
    let response = await Repository.get(resource)
    return response.data.districts
  }
}
